<section ng-controller="WorkUnitDetailsController as unitCtrl">
    <c-auto-form ng-if="unitCtrl.showDetails() " config="unitCtrl.autoFormConfig"></c-auto-form>
</section>